export default {
  Login: {
    user: 'ユーザー',
    password: 'パスワード',
    required: 'このフィールドは必須です',      //'필수 입력항목입니다.'
    loginFail: '不正なユーザーIDまたはパスワードです',
    submit: '差し出す'
  },
  Dashboard: {
    dashboard: 'ダッシュボード',
    os: 'オペレーティングシステム',
    architecture: 'アーキテクチャ',
    processor: 'プロセッサー',
    address: 'ホストアドレス',
    memory: 'メモリー',
    storage: 'ストレージ'
  },
  channel: {
    configuration: '設定',
    configurator: '設定',

    driver: 'ドライバ',
    driverid: 'ドライバ名',
    driverid_tip: '重複しない ドライバ 名',

    device: 'デバイス',
    deviceid: 'デバイス名',
    deviceid_tip: '重複しない デバイス名',

    channel: 'チャンネル',
    channelid: 'チャンネル名',
    channelid_tip: '重複しない チャンネル名',

    samplingtimeout: 'サンプリングタイムアウト時間',
    retryInterval: '再接続の待機時間',
    disabled: '無効',

    samplingtimeout_tip: 'サンプリング完了までの待機時間を指定します。',
    retryInterval_tip: '接続失敗時の再接続待機時間を指定します。',
    disabled_tip: '無効指定時はドライのすべての作業を停止します。'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/jp.js